import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Report, VoyageReportReportAndEventsData } from "@app/services/api/api.models";
import { Subscription } from "rxjs";
import { ApiService } from "@app/services/api/api.service";
import { VesselGroupsService } from "@app/services/vessel-groups/vessel-groups.service";
import { VesselReportsService } from "@app/services/reports/vessel-reports.service";

@Component({
  selector: "app-reports-table",
  templateUrl: "./reports-table.component.html",
  styleUrls: ["./reports-table.component.scss"],
})
export class ReportsTableComponent implements OnInit, OnDestroy {
  selectedVessel: any;

  @Input() reportAndEventsValues: VoyageReportReportAndEventsData[] = [];

  private activeDownloads: (string | number)[] = [];

  private subscriptions: Subscription[] = [];

  constructor(
    private apiService: ApiService,
    private vesselGroupsService: VesselGroupsService,
    public reportsService: VesselReportsService
  ) {}

  ngOnInit(): void {
    this.apiService
      .initialize()
      .toPromise()
      .then(() => {
        this.subscriptions.push(
          this.vesselGroupsService.getSelectedVesselObservable().subscribe({
            next: (selectedVessel) => {
              this.selectedVessel = selectedVessel;
            },
          })
        );
      });
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  isLoading(): boolean {
    return this.reportAndEventsValues === undefined;
  }

  getSanitizedEventName(name: string): string {
    return name.toLowerCase().replace(/\s+/g, "");
  }

  downloadReport(report: Report) {
    this.registerActiveDownload(report.id);
    this.reportsService.downloadReport(report).subscribe((id: number) => {
      this.removeActiveDownload(id);
    });
  }

  hasActiveDownload(id: string | number): boolean {
    return this.activeDownloads.indexOf(id) > -1;
  }

  private registerActiveDownload(id: string | number) {
    this.activeDownloads.push(id);
  }

  private removeActiveDownload(id: string | number) {
    const index = this.activeDownloads.indexOf(id);
    if (index > -1) {
      this.activeDownloads.splice(index, 1);
    }
  }
}
